<template>
<div class="div-table__row div-table__row--select">
  <span class="ml-12 ml-first-0">{{ offerIndex + 1 }}</span>
  <ui-select
    :value="offer"
    @change="onChange"
    :items="offerOptions"
    item-text="nameFull"
    item-value="id"
    :return-object="true"
    :error="generalErrorMessages"
    :fetchOptions="fetchOfferOptions"
    class="ml-12 flow-row-select"
    :hideDetails="1"
    :loading="!store.cache.offers.isUploaded"
  >
    <template #item="{ item, props: itemProps }">
      <v-list-item
        v-bind="listItemBind(itemProps)"
        :link="false"
        :title="null"
        @click.stop="onOfferItemClick(itemProps, $event)"
      >
        <div
          class="built-in-flow-item"
          :title="`${offerLabel(item)} (${offerItem(item).affiliateNetworkName || ''})`"
        >
          <div class="offer-select-item__main-block">
            {{ offerLabel(item) }}
          </div>
          <div
            v-if="offerItem(item).affiliateNetworkName"
            class="offer-select-item__affiliate-network"
          >
            {{ offerItem(item).affiliateNetworkName }}
          </div>
        </div>
      </v-list-item>
    </template>
  </ui-select>
  <div class="table-popup__input-weight">
    <v-text-field
      v-model="offer.weight"
      class="weight-input"
      type="number"
      density="compact"
      hide-details
      variant="plain"
      :disabled="isDisabledWeight || offersCount > 1"
      :error-messages="weightErrorMessages"
    ></v-text-field>
    <span :class="{ disabled: isDisabledWeight }" v-if="offersCount <= 1">({{ offerPercentage }}%)</span>
    <span :class="{ disabled: isDisabledWeight }" v-else>N/A</span>
  </div>
  <div class="table-popup__wrap-icon">
    <ui-icon
      v-if="offer.id"
      @click="emit('preview', offerUrl)"
      :disabled="checkPreviewAccess"
      size="14"
      :color="$colors.gray50"
      icon="fas fa-external-link"
    ></ui-icon>
    <ui-icon
      v-if="offer.id"
      @click="emit('edit')"
      size="14"
      :color="$colors.gray50"
      icon="fas fa-pencil-alt"
    ></ui-icon>
    <ui-icon
      v-if="offersCount <= 1"
      size="14"
      :color="$colors.gray50"
      @click="emit('delete')"
      icon="fas fa-trash-alt"
    ></ui-icon>
  </div>
</div>
</template>

<script setup lang="ts">
import { useStore } from '@/store';
import { useColors } from '@/composables';
import { useCampaignFlowOffer } from './useCampaignFlowOffer';

const store = useStore();

const $colors = useColors();
const props = withDefaults(
  defineProps<{
    path: {
      offers: Array<{ id: string; weight: number; url?: string }>;
    };
    ruleIndex: number;
    pathIndex: number;
    offerIndex: number;
    offer: { id: string; weight: number; url?: string };
    offersCount: number;
    isDisabledWeight?: boolean;
    totalWeight: number;
    errorConditionPrefix?: string[];
    errorsRaw: unknown[][] | null;
    offerOptions: Offer[];
    form: {
      workspaceId: string;
      countryId?: string;
    };
  }>(),
  {
    isDisabledWeight: false,
    errorConditionPrefix: () => [],
  },
);

const emit = defineEmits<{
  delete: [];
  edit: [];
  preview: [url: string];
}>();

const {
  fetchOfferOptions,
  generalErrorMessages,
  weightErrorMessages,
  offerUrl,
  checkPreviewAccess,
  offerPercentage,
  onChange,
} = useCampaignFlowOffer(props);

const offerItem = (item: { raw?: Offer } & Partial<Offer>) =>
  (item?.raw ?? item) as Offer;

const offerLabel = (item: { raw?: Offer } & Partial<Offer>) => {
  const offer = offerItem(item);
  return offer.nameFull || offer.name || '';
};

const listItemBind = (itemProps: Record<string, unknown>) => {
  const { title: _title, subtitle: _subtitle, onClick: _onClick, ...rest } = itemProps;
  return rest;
};

const onOfferItemClick = (
  itemProps: Record<string, unknown>,
  event: MouseEvent,
) => {
  if (itemProps.disabled) return;
  const handler = itemProps.onClick;
  if (typeof handler === 'function') {
    (handler as (event: MouseEvent) => void)(event);
  }
};
</script>
